import PropTypes from 'prop-types';
import React from 'react';

import { SubBold } from 'components/Sub';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

import AddButton from './AddButton';

const AddToCart = class extends React.PureComponent {
  handleOnClick = () => {
    this.props.addToCart();
    this.props.updateRecommendation();
  };

  render() {
    return (
      <div className="AddToCart">
        <button className="AddToCart__wrapper" onClick={this.handleOnClick}>
          <div className="AddToCart__drawer">
            <SubBold className="AddToCart__text">{I18n.localize('upsells.addToCart')}</SubBold>
            <AddButton />
          </div>
        </button>
        <style jsx>
          {`
            .AddToCart {
              background-color: ${Theme.get('colors-grey')};
            }

            .AddToCart__wrapper {
              width: 100%;
              padding: ${Theme.get('spacing') * 2}px ${Theme.get('spacing') * 3}px
                ${Theme.get('spacing') * 2}px;
              cursor: pointer;
              background: none;
              color: inherit;
              border: none;
              font: inherit;
              outline: inherit;
            }

            .AddToCart__drawer {
              display: flex;
            }
          `}
        </style>
        <style jsx global>
          {`
            .Sub.AddToCart__text {
              flex-grow: 1;
              text-align: left;
            }

            .AddToCart__wrapper:hover .AddButton__plus:before {
              transform: rotate(90deg);
            }

            .AddToCart__wrapper:hover .AddButton__plus:after {
              transform: rotate(180deg);
            }
          `}
        </style>
      </div>
    );
  }
};

AddToCart.propTypes = {
  addToCart: PropTypes.func,
  updateRecommendation: PropTypes.func,
};

AddToCart.defaultProps = { addToCart: () => {}, updateRecommendation: () => {} };

export default AddToCart;
